import useFormComment from '../../customHooks/useFormComment';
import styles from "./formComponent.module.css"
const FormComponent = () => {
  const {commentInfo,email,handleForm,setCommentInfo,setEmail} = useFormComment();
  return (
   <div className={`${styles.formContainer}`}>
      <form onSubmit={(e)=>handleForm(e)}>
        <input value={email} onChange={(e)=>setEmail(e.target.value)} type="text" placeholder='Email' />
        <textarea value={commentInfo} onChange={(e)=>setCommentInfo(e.target.value)} placeholder='Make your Comment'></textarea>
        <button>Add comment</button>
    </form>
   </div>
  )
}

export default FormComponent